import React, { useMemo } from 'react';
import { GaugeChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { buildGaugeData, buildChartTitle } from "../chartHelpers";

const Index = ({chart}) => {
    const chartOptions = useMemo(() => ({
        title: buildChartTitle(chart),
        resizable: true,
        height: "400px",
        gauge: {
            type: "semi",
            status: "danger",
            numberFormatter: (val) => val != null ? val.toFixed(2) : '—',
        },
    }), [chart]);

    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData, renderChart) => {
                const data = buildGaugeData(panelData, chart);
                return renderChart(data, <GaugeChart options={chartOptions} data={data} />);
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
